<template>
<div>
    <b-container>

        <b-row>
            <b-col>
                <br />
                <b-breadcrumb :items="items"></b-breadcrumb>
            </b-col>
        </b-row>

        <b-row class="content">
            <b-col>
                <div v-if="viewPortfolio">
                    <portfolio :catToView="'viewPortfolioSingleOnly'" :catKey="this.IdToView"></portfolio>
                </div>
                <div v-else>
                    <b-card class="shadow" no-body>
                        <b-tabs pills card fill>
                            <b-tab :title="this.website" active>
                                <b-card-text>
                                    <portfolio :catToView="'website'" :catKey="''" ></portfolio>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="this.corporate_video">
                                <b-card-text>
                                    <portfolio :catToView="'corpovideo'" :catKey="''" ></portfolio>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="this.graphic_design">
                                <portfolio :catToView="'graphicdesign'" :catKey="''" ></portfolio>
                            </b-tab>
                            <b-tab :title="this.tv_and_webtv">
                                <b-card-text>
                                    <portfolio :catToView="'tvprogram'" :catKey="''" ></portfolio>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="this.commercial">
                                <b-card-text>
                                    <portfolio :catToView="'commercial'" :catKey="''" ></portfolio>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="this.logocreation">
                                <b-card-text>
                                    <portfolio :catToView="'logocreation'" :catKey="''" ></portfolio>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="this.radio">
                                <b-card-text>
                                    <portfolio :catToView="'radio'" :catKey="''" ></portfolio>
                                </b-card-text>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>

            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
//bus for handling component interconnection
import {
    EventBus
} from "@/event-bus.js";
import axios from "axios";
import {
    globalSiteSetting
} from "../main.ts";
export default {
    data() {
        return {
            wurl: globalSiteSetting.siteurl,
            langfrench: true,
            items: [],
            items_fr: [{
                    text: "Accueil",
                    to: "/",
                },
                {
                    text: "Nos réalisations",
                    active: true,
                },
            ],
             items_en: [{
                    text: "Home",
                    to: "/",
                },
                {
                    text: "Work",
                    active: true,
                },
            ],
            langfrench: true,

            website:'Site web',
            corporate_video:'Reportage vidéo',
            graphic_design:'Création graphique',
            tv_and_webtv:'Emission TV et TV Web',
            commercial:'Publicité',
            logocreation:'Création Logo',
            radio:'Pub radio',

            CatToView: "",
            IdToView: 0,
            content_fr: "",
            title_fr: "fdfddf",
            portfolio_categorie_fr: "",

            content_en: "",
            title_en: "",
            portfolio_categorie_en: "",

            portfolio_pic: "",
            portfolio_pic_en: "",

            portfolio_pic_detail_fr: "",
            portfolio_pic_detail_en: "",

            headerpic: "ajaxloader.gif",

            portfolio_website_en: [],
            portfolio_corpovideo_en: [],
            portfolio_graphicdesign_en: [],
            portfolio_tvprogram_en: [],
            portfolio_commercial_en: [],
            portfolio_logocreation_en: [],
            portfolio_radio_en: [],

            portfoliosingle: [],
            viewPortfolio: false,

            fromHome: false
        };
    },
    methods: {

        scrollToTop() {
            // scroll on top every load page
            window.scrollTo(0, 0);
        },
        togglefrenchlangage() {
            this.langfrench = true
            this.items = this.items_fr
            this.website = 'Site web',
            this.corporate_video = 'Reportage vidéo',
            this.graphic_design = 'Création graphique',
            this.tv_and_webtv ='Emission TV et TV Web',
            this.commercial ='Publicité',
            this.logocreation = 'Création Logo',
            this.radio = 'Pub radio'
            //console.log('lang is now french')
            //change page title
            window.document.title = 'Graphikodesign | Nos Réalisations'
        },
        toggleenglishlangage() {
            this.langfrench = false
            this.items = this.items_en
            this.website = 'Website',
            this.corporate_video = 'Corporate Video',
            this.graphic_design = 'Graphic Design',
            this.tv_and_webtv ='TV and Web TV',
            this.commercial ='Commercial',
            this.logocreation = 'Logo creation',
            this.radio = 'Radio'
            
            //change page title
            window.document.title = 'Graphikodesign | Works'
            //console.log('lang is now english')
        },
               checkifcookieexistornot() {

            if (this.$cookie.get('gd_cookie') === 'accepted' || this.$cookie.get('gd_cookie') === 'rejected') {

                // try to read lang conf
                if (this.$cookie.get('gd_cookie') === 'accepted') {
                    if (this.$cookie.get('gd_langinfrench') === 'true') {
                        this.langfrench = true
                        this.items = this.items_fr
                        this.togglefrenchlangage()
                         EventBus.$emit('togglelangtofrench')
                    }
                    else
                     {
                         this.langfrench = false
                         this.items = this.items_en
                         this.toggleenglishlangage()
                          EventBus.$emit('togglelangtoenglish')
                     }
                }

            } else {
                this.askforcookie()
            }
        }
    },

    mounted() {
        //this.retrievedata();
        this.scrollToTop();

        this.checkifcookieexistornot()

               if (this.langfrench == true) {
            this.items = this.items_fr
            //change page title
            window.document.title = 'Graphikodesign | Nos Réalisations'
        } else {
            this.items = this.items_en
            //change page title
            window.document.title = 'Graphikodesign | Works'
        }
        //listen to langage change
        EventBus.$on('togglelangtofrench', () => {
            this.togglefrenchlangage()
        })
        EventBus.$on('togglelangtoenglish', () => {
            this.toggleenglishlangage()
        })
    }

};
</script>
